/**
 * Navigation copy: the top bar, the sidebar, the «سجل معنا» (Join us) menu and
 * the footer's photo-credits link. Used through useTranslation('nav') or the
 * nav: prefix. Keys must match ar/nav.ts exactly.
 */
const nav = {
  skipToContent: 'Skip to content',

  menu: {
    open: 'Open menu',
    close: 'Close menu',
    title: 'Menu',
  },

  // Top-bar headings
  top: {
    rent: 'For Rent',
    buy: 'For Sale',
    invest: 'For Investment',
    nonSaudi: 'Non-Saudi Ownership',
    findPro: 'Find a professional',
    services: 'Services',
  },

  // "For Rent" and "For Sale" menus
  browse: {
    all: 'All',
    residential: 'Residential',
    commercial: 'Commercial',
    rentAllDesc: 'Browse everything to rent',
    rentResidentialDesc: 'Homes & apartments',
    buyAllDesc: 'Browse everything for sale',
    buyResidentialDesc: 'Homes, apartments & land',
    commercialDesc: 'Offices, shops, warehouses & more',
  },

  // "For Investment" menu
  invest: {
    hub: 'Investors Hub',
    hubDesc: 'Where developers meet investors',
    specialDeals: 'Special deals',
    specialDealsDesc: 'Subscriber-only opportunities',
    licensedProjects: 'Licensed projects (sale/rent)',
    licensedProjectsDesc: 'Invest in licensed projects for sale or rent',
    contributions: 'Real-estate contributions',
    contributionsDesc: 'Contribute funding to licensed projects',
    requests: 'Investment requests',
    requestsDesc: 'For developers seeking investment opportunities',
    list: 'List for investment',
    listDesc: 'Offer your property to investors',
  },

  // "Find a professional" menu
  findPro: {
    brokers: 'Brokers & marketers',
    brokersDesc: 'Trusted brokers and marketers',
    developers: 'Real-estate developers',
    developersDesc: 'Real-estate development companies',
    propertyManagement: 'Property management',
    propertyManagementDesc: 'Manage owners’ assets',
    facilitiesManagement: 'Facilities management',
    facilitiesManagementDesc: 'Operate & maintain facilities',
    appraisers: 'Appraisers',
    appraisersDesc: 'Property valuation',
    brokersMap: 'Brokers map',
    brokersMapDesc: 'Experts near you',
  },

  // "Services" menu and the sidebar's "Our services" card
  services: {
    listPropertyDesc: 'Add your property for sale or rent',
    postRequestDesc: 'Post a request, get matched',
    subscriptionsDesc: 'Plans & pricing',
    marketTools: 'Market intelligence',
    marketToolsDesc: 'Prices and rents from registered deals',
    proServices: 'Professional services',
    requestsBoard: 'Requests board',
    addons: 'Add-ons',
    bundles: 'Bundles',
    coins: 'Coins',
    myAddons: 'My add-ons',
  },

  // The «سجل معنا» button and its menu
  register: {
    cta: 'Join us',
    createAccount: 'Create account',
    createAccountDesc: 'A free account to save favourites and track your requests',
    asProfessional: 'Register as a professional',
    developer: 'Real-estate developer',
    developerDesc: 'Market & build projects',
    broker: 'Broker & marketer',
    brokerDesc: 'List & market properties',
    propertyManagement: 'Property management',
    propertyManagementDesc: 'Manage owners’ assets',
    facilitiesManagement: 'Facilities management',
    facilitiesManagementDesc: 'Operate & maintain facilities',
    appraiser: 'Appraiser',
    appraiserDesc: 'Value properties',
  },

  signIn: 'Sign in',

  // Language names in their own language (same values in both files)
  language: {
    ar: 'العربية',
    en: 'English',
  },

  account: {
    grow: 'Grow your account',
    menu: 'Account menu',
  },

  enquiriesUnread: 'Enquiries, {{n}} unread',

  sidebar: {
    guestTitle: 'Sign in for a personalised experience',
    guestBody: 'Save favourite properties and follow your requests and listings in one place.',
    noAccount: 'No account yet?',
    properties: {
      title: 'Properties',
      subtitle: 'Rent, buy and invest',
    },
    // The title is common:navigation.postRequest
    postRequest: {
      subtitle: 'Tell us what you need',
    },
    services: {
      title: 'Our services',
      subtitle: 'Market intelligence, plans and add-ons',
    },
    findPro: {
      title: 'Find a professional',
      subtitle: 'Brokers, developers and specialists',
    },
    registerPro: {
      title: 'Join as a professional',
      subtitle: 'Developers, brokers and specialists',
    },
    account: {
      title: 'My account',
      subtitle: 'Profile, listings and requests',
    },
    help: {
      title: 'Help & support',
      subtitle: 'About, contact and complaints',
      liveChat: 'Live support',
    },
    comingSoon: 'Coming soon',
    language: 'Language',
    theme: 'Appearance',
    signOut: 'Sign out',
  },

  badges: {
    broker: 'Broker',
    company: 'Company',
    individual: 'Individual',
    developer: 'Developer',
  },

  theme: {
    switchToLight: 'Switch to light mode',
    switchToDark: 'Switch to dark mode',
  },

  // "List your property" notices for brokers and companies (moved from Navigation)
  listProperty: {
    falRejected: 'Your FAL license was rejected. Please re-submit from your account settings.',
    falPending: "Your FAL license is pending verification. You'll be notified when it's approved.",
  },

  footer: {
    photoCredits: 'Photo credits',
  },
};

export default nav;
